import { Component, Input, Output, EventEmitter, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Delegation } from '../../api/model/delegation';
import { EdeskStateService } from '../../core/edesk-state.service';

@Component({
    selector: 'app-edesk-selector',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './edesk-selector.component.html',
    styleUrls: ['./edesk-selector.component.scss']
})
export class EdeskSelectorComponent {
    @Input() delegations: Delegation[] = [];
    @Output() edeskSelected = new EventEmitter<string>();
    @Output() cancelled = new EventEmitter<void>();

    edeskStateService = inject(EdeskStateService);

    selectEdesk(uri: string): void {
        this.edeskStateService.setSelectedEdeskUri(uri);
        this.edeskSelected.emit(uri);
    }

    cancel(): void {
        this.cancelled.emit();
    }

    shortUri(uri: string | undefined): string {
        if (!uri) return '';
        const lastSlash = uri.lastIndexOf('/');
        return lastSlash >= 0 ? uri.substring(lastSlash + 1) : uri;
    }
}
